import React from 'react';
import { Container, Wrap } from '@fiverr-private/layout_components';
import { translate } from '../../../../utils/translate';
import { CreateBanner } from './CreateBanner';

import logo1 from './assets/unilever.svg';
import logo2 from './assets/similarweb.svg';
import logo3 from './assets/my-heritage.svg';
import logo4 from './assets/rainforest-alliance.svg';
import logo5 from './assets/888.svg';

const LOGOS: [string, string][] = [
    [logo1, 'Uniliever'],
    [logo2, 'Similarweb'],
    [logo3, 'MyHeritage'],
    [logo4, 'Rainforest Alliance'],
    [logo5, '888'],
];

const IMAGE =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/db0653940f96a26cdd7bdee5f61c3545-1750845528838/sign-business-default-banner-lg.png';

export const DefaultBanner: React.FC = () => (
    <CreateBanner
        imageSrcMd={IMAGE}
        imageSrcLg={IMAGE}
        title={translate('image_banner.default_title')}
        titleSize="b_md"
        titlePaddingY="16"
        extraContent={
            <Wrap marginTop="6" justifyContent="center" gap="2" maxWidth={250}>
                {LOGOS.map(([logo, alt]) => (
                    <Container key={logo}>
                        <img key={logo} src={logo} alt={alt} />
                    </Container>
                ))}
            </Wrap>
        }
    />
);
